import './Footer.css'

const Footer: React.FC = () => (
  <footer>
    <p>© {new Date().getFullYear()} Lukas Aleknavicius. All rights reserved.</p>
  </footer>
);

export default Footer;
